import Model, { attr } from '@ember-data/model';
import currency from 'currency.js';

export default class FundSummaryYtdGoalModel extends Model {
  @attr('number') declare annualGoal: number;
  @attr('number') declare givenAmount: number;
  @attr('number') declare givenPercent: number;
  @attr('number') declare expectedAmount: number;
  @attr('number') declare expectedPercent: number;
  @attr('number') declare recurringPledgesAmount: number;
  @attr('number') declare recurringPledgesPercent: number;

  get totalAmount() {
    return currency(this.givenAmount).add(this.expectedAmount).value;
  }

  get totalPercent() {
    return this.givenPercent + this.expectedPercent;
  }
}
